import { stringify } from 'qs'
import AnchorButton from '../AnchorButton'
import { CSVButtonProps } from './types'
import { useProjectContext } from 'context/ProjectContext'
import { REACT_APP_BACK_END_URL } from 'config'

const CSVButton: React.VFC<CSVButtonProps> = ({
  entity,
  label = 'CSV Export',
  primary,
}) => {
  const { projectId } = useProjectContext()
  const url = `${REACT_APP_BACK_END_URL}/api/projects/${projectId}/csv?${stringify(
    { entity: entity.queryParameter },
    { encode: true }
  )}`

  return (
    <AnchorButton type={primary ? 'primary' : undefined} href={url}>
      {label}
    </AnchorButton>
  )
}

export default CSVButton
